import { CHANGE_CONNEXION, CHANGE_CATEGORIES, CHANGE_FOODS, CHANGE_ALLERGENS, CHANGE_IMAGES, CHANGE_COUNT, CHANGE_POPUPS, CHANGE_POPUPC } from "./action-types";

export function changeCategories(payload) {
  return { type: CHANGE_CATEGORIES, payload }
};

export function changePopupS(payload) {
  return { type: CHANGE_POPUPS, payload }
};

export function changePopupC(payload) {
  return { type: CHANGE_POPUPC, payload }
};

export function changeFoods(payload) {
  return { type: CHANGE_FOODS, payload }
};

export function changeAllergens(payload) {
  return { type: CHANGE_ALLERGENS, payload }
};

export function changeImages(payload) {
  return { type: CHANGE_IMAGES, payload }
};

export function changeCount(payload) {
  return { type: CHANGE_COUNT, payload }
};

export function changeConnexion(payload) {
  return { type: CHANGE_CONNEXION, payload }
};


// WEBPACK FOOTER //
// ./src/actions/index.js